/**
 * @generated SignedSource<<3e9c7e30c83450f59aaac253fae2b668>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type previewPublishedProductsQuery$variables = {
  productStatusID?: number | null;
};
export type previewPublishedProductsQuery$data = {
  readonly models: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null;
  } | null;
};
export type previewPublishedProductsQuery = {
  response: previewPublishedProductsQuery$data;
  variables: previewPublishedProductsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productStatusID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      },
      {
        "kind": "Variable",
        "name": "productStatusID",
        "variableName": "productStatusID"
      }
    ],
    "concreteType": "ModelsConnection",
    "kind": "LinkedField",
    "name": "models",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "previewPublishedProductsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "previewPublishedProductsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a25c7d90b9c9f2fd040ecbef508b2f54",
    "id": null,
    "metadata": {},
    "name": "previewPublishedProductsQuery",
    "operationKind": "query",
    "text": "query previewPublishedProductsQuery(\n  $productStatusID: Int\n) {\n  models(first: 1, productStatusID: $productStatusID) {\n    nodes {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ff987744551506872d5953e620e6fc0";

export default node;
